export default __webpack_public_path__ + "static/media/dx_071101.44bb97ae.jpg";